import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { getDevicesStatusesRequest, getHistoryDevicesRequest, getDevicesSubstatusesRequest, patchDevicesRequest, getDevicesRequest, setDeviceSelected } from '../../actions/devices';
import { getGpsDevicesRequest } from '../../actions/gps';
import { devicesSelector } from '../../selectors/devices';
import { gpsSelector } from '../../selectors/gps';
import DeviceDetail from './DeviceDetail';

const mapStateToProps = createStructuredSelector({
    devices: devicesSelector,
    gps: gpsSelector
});

const mapDispatchToProps = {
    getDevicesStatusesRequest,
    getHistoryDevicesRequest,
    getGpsDevicesRequest,
    getDevicesSubstatusesRequest,
    patchDevicesRequest,
    getDevicesRequest,
    setDeviceSelected
};

export default connect(mapStateToProps, mapDispatchToProps)(DeviceDetail);
